module.exports = "/assets/data/9860c8461d1253f39842c30a233bee2a-SY2.data.json";